import React from "react";
import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-50px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Reveal = ({ children, className = "" }) => (
  <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2 }}
    className={className}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ eyebrow, title, intro, image, video, poster, testId = "page-header" }) => (
  <section
    className="relative min-h-[70vh] flex items-end"
    data-testid={testId}
  >
    <div className="absolute inset-0 overflow-hidden">
      {video ? (
        <video
          key={video}
          src={video}
          poster={poster || image}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
      ) : image ? (
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover kenburns"
          loading="eager"
        />
      ) : null}
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/40" />
    </div>
    <div className="relative px-6 sm:px-10 lg:px-16 pb-20 pt-44 w-full">
      <div className="max-w-4xl">
        <FadeUp>
          <div className="overline mb-5">{eyebrow}</div>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.02] tracking-tight">
            {title}
          </h1>
        </FadeUp>
        {intro && (
          <FadeUp delay={0.2}>
            <p className="mt-8 text-lg text-white/80 max-w-2xl leading-relaxed">
              {intro}
            </p>
          </FadeUp>
        )}
      </div>
    </div>
    <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
  </section>
);

export const SectionHeader = ({ eyebrow, title, subtitle, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <FadeUp>
        <div className="overline mb-5">{eyebrow}</div>
      </FadeUp>
    )}
    <FadeUp delay={0.05}>
      <h2 className="font-display text-4xl sm:text-5xl text-navy leading-[1.05]">
        {title}
      </h2>
    </FadeUp>
    {subtitle && (
      <FadeUp delay={0.1}>
        <p className="mt-5 text-base text-navy/70 leading-relaxed">{subtitle}</p>
      </FadeUp>
    )}
  </div>
);
